<app-modal
  [modalTitle]="'Selecionar usuário para assumir o perfil'"
  width="70vw"
  [closable]="closabe"
  (closeModal)="close()"
  [display]="open">
  <section class="grid" [formGroup]="form">
    <div class="col-12 texto-azul">
      Informe uma das informações do usuário Master
    </div>
    <div class="input-group field lg:col-2 md:col-6 col-12">
      <p-floatlabel variant="on" class="mt-3">
        <input
          class="w-full"
          formControlName="idUsuario"
          id="idUsuario"
          type="text"
          pInputText />
        <label for="idUsuario">Código</label>
      </p-floatlabel>
    </div>
    <div class="input-group field lg:col-3 md:col-6 col-12">
      <p-floatlabel variant="on" class="mt-3">
        <input
          class="w-full"
          formControlName="login"
          id="login"
          type="text"
          pInputText />
        <label for="login">Login</label>
      </p-floatlabel>
    </div>
    <div class="input-group field lg:col-3 md:col-6 col-12">
      <p-floatlabel variant="on" class="mt-3">
        <input
          class="w-full"
          formControlName="email"
          id="email"
          type="text"
          pInputText />
        <label for="email">E-mail</label>
      </p-floatlabel>
    </div>
    <div class="lg:col-3 md:col-6 col-12 container-button">
      <p-button
        (click)="search()"
        label="Pesquisar"
        class="btn-azul-padrao"
        title="Buscar usuários"
        type="button"
        icon="pi pi-search"
        iconPos="left"></p-button>
    </div>
  </section>
  <dx-data-grid
    #dataGrid
    class="grid-container col-12"
    [width]="'100%'"
    [dataSource]="dataSource"
    [columns]="columns"
    [filterRow]="{ visible: true, applyFilter: 'auto' }"
    [headerFilter]="{ visible: true }"
    [hoverStateEnabled]="true"
    [showBorders]="true"
    [columnMinWidth]="100">
    <dxo-toolbar>
      <dxi-item location="after" name="searchPanel"></dxi-item>
    </dxo-toolbar>

    <div
      class="flex justify-content-center"
      *dxTemplate="let row of 'buttonsTemplate'">
      <p-button
        (click)="assumirPerfil(row?.data)"
        class="btn-verde btn-icone mr-1"
        title="Clique para configurar este fornecedor"
        icon="pi pi-check"
        label="Assumir Perfil"></p-button>
    </div>
  </dx-data-grid>
</app-modal>
